import { buildComponent } from '#components'

export const ContactForm = buildComponent({
  name: 'contact-form',
  onConnected: (component) => {
    const formEl = component.querySelector('.js-contact-form') as HTMLFormElement
    const formObserverConfig = {
      config: { attributes: true },
      callback: (mutations: MutationRecord[]) => {
        mutations.forEach((mutation) => {
          const target = mutation.target as HTMLElement

          if (mutation.attributeName === 'onsubmit') {
            target.removeAttribute('onsubmit')
          }
        })
      }
    }
    const formObserver = new MutationObserver(formObserverConfig.callback)

    if (formEl) {
      formObserver.observe(formEl, formObserverConfig.config)

      formEl.addEventListener('submit', async (e) => {
        e.preventDefault()

        const params = new URLSearchParams()
        const formData = new FormData(formEl)

        for (const key of formData.keys()) {
          params.set(key, formData.get(key) as string)
        }

        try {
          await fetch('/contact', {
            method: 'POST',
            body: params,
            redirect: 'follow',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          })
          formEl.classList.add('_successful')
          window.scrollTo({ top: 0, behavior: 'smooth' })
          document.body.classList.add('contact-form-submitted')
        } catch (error) {
          // eslint-disable-next-line
          console.error(error)
          formEl.classList.remove('_successful')
          document.body.classList.remove('contact-form-submitted')
        }

        return false
      })
    }
  }
})

declare global {
  interface HTMLElementTagNameMap {
    'contact-form': typeof ContactForm
  }
}
